import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const CorporationService = {
    headerTemplates: async () => axios.get(API_URL + "/corporation/getTemplates").then(({data}) => data).catch((err) => { throw err }),
    edit: async (data) => axios.post(API_URL + `/corporation`, data).then(({data}) => data).catch((err) => { throw err }),
    initData: async () => axios.get(API_URL + "/corporation/init-data").then(({data}) => data).catch((err) => { throw err }),
    entity: async () => axios.get(API_URL + "/corporation/getEntity").then(({data}) => data).catch((err) => { throw err }),
    mapsKey: async () => axios.get(API_URL + "/corporation/mapsKey").then(({data}) => data).catch((err) => { throw err })
}

export default CorporationService;